module.exports = __webpack_public_path__ + "img/mine.3c887219.png";